import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  /* eslint-disable */
  showPleaseWait: false,
  alreadySubmittedUser: false,
  showThankYouEmailModal: false,
  puzzleGame: null,
  lanternGame: null,
  freePlayPrize: null,
  celebrityInfo: null,
  checkedNotificationId: '',
  checkedNotificationReadStatus: false,
  notificationRewardId: '',
  notificationPrizeWon: false,
  notificationRewardName: '',
  achievements:[],
  bonusDailyModal: null,
  phaseBonusModalToBeDisplayed: {},
  phaseBonusList: [],
  gameHistoryDataForToday: [],
  gameHistoryDataForOtherDays: [],
  isUserConnected: false,
  hashedPass: null,
  twoStepVerificationWrongPin: null,
  twoStepVerificationServerError: null,
  twoStepVerificationVerified: null,
  forgotPasswordInfo: '',
  achievementNotificationData: [],
  notificationsNames: {
    grandPrize: 'Grand Prize',
    dailyPrize: 'Daily Prize',
    weeklyPrize: 'Weekly Prize',
    monthlyPrize: 'Monthly Prize',
    topRanking: 'Top Ranking',
    levelUp: 'Level Up',
  },
  prizes: {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    GRAND: 'GRAND',
  },
  showmodalForRanking: {
    userLevel: '',
    bonusPoints: '',
    gamesEarned: '',
  },
  showmodalForLevelUp: {
    userLevel: '',
    bonusPoints: '',
    gamesEarned: '',
  },
  moreWinnersButton: false,
  numberOfDefaultDisplayWinners: 5,
  extraArraysWinners: [],
  visitorWinners: [],
  monthlyPrize: {},
  grandPrize: {},
  dailyPrize: {},
  weeklyPrize: {},
  carouselPrizes: [],
  requestPinResponse: null,
  chargePinResponse: null,
  storedBundles: [],
  registrationInfoMsisdn: '',
  monthlyPrizeForLeaderboard: [],
  grandPrizeForLeaderboard: [],
  dailyPrizeForLeaderboard: [],
  weeklyPrizeForLeaderboard: [],
  monthlyWinnersForLeaderboard: [],
  dailyWinnersForLeaderboard: [],
  weeklyWinnersForLeaderboard: [],
  grandWinnersForLeaderboard: [],
  monthlyRankForLeaderboard: [],
  grandRankForLeaderboard: [],
  dailyRankForLeaderboard: [],
  weeklyRankForLeaderboard: [],
  availablePrizeTypes: [],
  showmodalForDefaultPrizeDetails: false,
  jwtInVuex: '',
  firstTimeEntry: false,
  userAuthorized: false,
  profilePath: false,
  bundleId: 0,
  bundleData: {
    numberOfGames: '',
    price: '',
    currencyCode: '',
    points: '',
  },
  themes: [],
  notifications: [],
  gameHistoryData: [],
  opponentDetails: {},
  gameDescriptionDetails: {},
  showHistory: false,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/index.js